module.exports = __webpack_public_path__ + "img/ok-request-icon.d347d325.svg";